export const USERS_FETCH='USERS_FETCH';
export const USERS_FETCH_ALL='USERS_FETCH_ALL';
export const USERS_IS_FETCING='USERS_IS_FETCHING';
export const USERS_API='users';
export const USER_EDIT='USER_EDIT';
export const USER_SAVE='USER_SAVE';
export const USERS_FILTER='USERS_FILTER';



// WEBPACK FOOTER //
// ./src/constants/users.js